import type { YzcNotifyOption } from '../types'
import { setDebug } from '../debug'
import { NotifyQueue } from '../NotifyQueue'
import { YzcNotify } from '../YzcNotify'

type YzcNotifyOptionWithDebug = YzcNotifyOption & {
  /** 是否开启debug */
  debug?: boolean
}

export function init(w: Window) {
  let yzcNotifyInstance: YzcNotify

  function getYzcNotifyInstance(option: YzcNotifyOptionWithDebug) {
    if (!yzcNotifyInstance) {
      yzcNotifyInstance = new YzcNotify(option, new NotifyQueue())
    }
    setDebug(option.debug)
    return yzcNotifyInstance
  }

  w.YzcNotify = { getYzcNotifyInstance }
}
